import { getCountries } from "../../js/api/countries.js";
import { getLeagues } from "../../js/api/leagues.js";
import { _t } from "../../services/TranslationService.js";
import Utils from "../../services/Utils.js";
import {
  getGames,
  getLiveLeftPanelGames,
  getGamesByCountry,
} from "../../js/api/gameByLeagues.js";
import { getGameTemplate } from "../templates/game.js";
import { getSearchGames } from "../../js/api/search.js";
import { getSearchingGames } from "../templates/search-games.js";
import { prevHash, lastHash } from "../../services/state.js"; // adjust path as needed
import { getSports } from "../../js/api/sports.js";
import {
  filterBlockedSports,
  isSportBlocked,
} from "../../services/BlockedSports.js";

let sports = [];
const LIVE_SPORT_IDS = [1, 2, 5, 20];

async function getDefaultAllowedSportId() {
  const allowedSports = filterBlockedSports(
    await getSports({ ttlMinutes: 10 })
  ).filter((sport) => sport && sport.id != 13 && sport.id != 15);
  const defaultSport =
    allowedSports.find((sport) => String(sport.id) === "1") ||
    allowedSports[0];

  return defaultSport ? String(defaultSport.id) : null;
}

let Leftpanel = {
  render: async () => {
    let request = Utils.parseRequestURL();
    let matchSport = localStorage.getItem("matchSport");

    let countries = "";
    const currentUrl = window.location.hash; // Get current hash URL
    if (
      currentUrl.startsWith("#/Match/") ||
      currentUrl.startsWith("#/match/")
    ) {
      localStorage.setItem("matchSport", matchSport);
      matchSport = localStorage.getItem("matchSport");
      countries = isSportBlocked(matchSport)
        ? []
        : (await getCountries(matchSport)) || [];
    } else if (currentUrl === "" || currentUrl === "#/") {
      matchSport = await getDefaultAllowedSportId();
      if (matchSport) {
        localStorage.setItem("matchSport", matchSport);
        countries = (await getCountries(matchSport)) || [];
      } else {
        countries = [];
      }
    } else if (
      currentUrl === "#/inplay" ||
      currentUrl.startsWith("#/livematch/")
    ) {
      localStorage.setItem("matchSport", "0");
      matchSport = localStorage.getItem("matchSport");

      const allowedLiveSportIds = LIVE_SPORT_IDS.filter(
        (sportId) => !isSportBlocked(sportId)
      );
      const liveSportGames = await Promise.all(
        allowedLiveSportIds.map(
          async (sportId) => (await getLiveLeftPanelGames(sportId)) || []
        )
      );

      countries = [].concat(...liveSportGames);

      try {
        const ids = [
          ...new Set(
            (countries || []).map((x) => String(x.id)).filter(Boolean)
          ),
        ];
        localStorage.setItem("lastLiveIds", JSON.stringify(ids));
        localStorage.setItem("lastLiveIdsReady", "1");
      } catch {}
      // <<<
    } else {
      if (isSportBlocked(request.id)) {
        countries = [];
      } else {
        localStorage.setItem("matchSport", request.id);
        matchSport = localStorage.getItem("matchSport");
        countries = (await getCountries(request.id)) || [];
      }
    }

    // 3) Build the country rows
    let countryView = "";
    for (const country of countries) {
      // Group live matches by sport-id
      if (matchSport === "0") {
        const groupedSports = {};

        for (const country of countries) {
          if (!groupedSports[country.sport_id]) {
            groupedSports[country.sport_id] = [];
          }
          groupedSports[country.sport_id].push(country);
        }

        countryView = Object.keys(groupedSports)
          .map((sportId) => {
            let sportName = "";
            let sportIcon = "";

            switch (parseInt(sportId)) {
              case 1:
                sportName = "Football";
                sportIcon = "soccer.svg";
                break;
              case 2:
                sportName = "Basketball";
                sportIcon = "basketball.svg";
                break;
              case 5:
                sportName = "Tennis";
                sportIcon = "tennis.svg";
                break;
              case 20:
                sportName = "Ping Pong";
                sportIcon = "table.svg";
                break;
              default:
                sportName = "Other Sports";
                sportIcon = "default.svg";
                break;
            }

            // Group by league within this sport
            const leagueGroups = {};
            groupedSports[sportId].forEach((match) => {
              if (!leagueGroups[match.league]) {
                leagueGroups[match.league] = [];
              }
              leagueGroups[match.league].push(match);
            });

            // Render league sections
            const leaguesHtml = Object.entries(leagueGroups)
              .map(([leagueName, matches]) => {
                return `
                    <div class="league-group w-full">
                        <div class="league-title bg-[rgba(0,0,0,.7)] text-white px-4 py-2 text-[11px] font-normal border-b border-[#444] cursor-pointer">
                        ${_t(leagueName)}
                        </div>
                        ${matches
                          .map(
                            (country) => `
                        <div class="w-full relative">
                            <a 
                            href="#/livematch/${country.id}?sportId=${country.sport_id}"
                            class="flex flex-wrap w-full duration-300 ease-in-out justify-between items-center bg-black bg-opacity-[0.4] px-2 py-[1px] border-[#3d3d3d] border-b border-dotted cursor-pointer hover:bg-[#8d741d]"
                            data-id="${country.id}">
                            <div class="flex flex-row flex-wrap items-center w-full">
                                <span class="text-white text-[11px] w-[22px]">${country.current_minute}</span>
                                <span class="text-white text-[11px] max-w-[calc(100%-42px)] w-full truncate px-2">${country.name}</span>
                                <span class="text-white text-[11px] max-w-[50px] w-[20px] truncate">${country.result}</span>
                            </div>
                            </a>

                            <!-- Favorite toggle button -->
                            <div 
                            class="fav-toggle flex flex-wrap flex-col h-[calc(100%-1px)] w-[22px] absolute z-2 left-1 top-0 bg-[#202020] opacity-0 hover:opacity-100 cursor-pointer" 
                            id="${country.id}"
                            data-id="${country.id}"
                            data-name="${country.name}"
                            data-sport-id="${country.sport_id}"
                            data-result="${country.result}"
                            data-minute="${country.current_minute}"
                            title="Toggle favorite">
                            <img class="w-full h-full object-contain p-1" src="./img/ILL.png">
                            </div>
                        </div>
                        `
                          )
                          .join("")}
                    </div>
                `;
              })
              .join("");

            // Final render of sport + grouped leagues
            return `
        <div class="sport-group">
          <div class="sport-header flex flex-row items-center space-x-2 bg-[#333] border-b border-[#3d3d3d] text-white px-2 py-1 font-bold bg-gradient-to-t from-[#232323] via-[#333333] to-[#494949] cursor-pointer relative">
            <img class="w-[18px] h-[18px]" src="./img/${sportIcon}" alt="${sportName}" />
            <span class="text-white text-[11px] leading-[17px]">${_t(
              sportName
            )}</span>
            <img src="./img/right.png" class="ml-auto w-[11px] absolute right-2 top-1/2 -translate-y-1/2 rotate-[90deg] transition-transform duration-300" />
          </div>
          <div class="sport-content open overflow-hidden transition-all duration-300 ease-in-out h-auto opacity-100">
            ${leaguesHtml}
          </div>
        </div>
      `;
          })
          .join("");
      } else {
        countryView += `
                    <div 
                        class="countryRow flex flex-wrap w-full duration-300 ease-in-out justify-between items-center px-2 py-1 border-[#3d3d3d] bg-black bg-opacity-[0.6] border-b border-dotted cursor-pointer hover:bg-[#8d741d]"
                        data-id="${country.id}"
                        data-loaded="false"
                    >
                        <div class="flex flex-row flex-wrap items-center space-x-2">
                            <img class="toggle-icon duration-300 ease-in-out w-[10px] h-[10px] transform" src="~/../img/right.png" />
                            <span class="text-white text-[11px] leading-[17px]">${_t(
                              country.name
                            )}</span>
                        </div>
                        <div class="flex flex-row flex-wrap items-center">
                            <span class="leagueCount text-[#ffcc00] text-[11px] leading-[17px]">(${
                              country.count_country
                            })</span>
                        </div>
                    </div>
                    <div 
                        id="league-container-${country.id}" 
                        class="leagueContainer border-b border-[#3d3d3d] bg-black bg-opacity-20 overflow-hidden"
                        style="height: 0; transition: height 0.3s ease;"
                        data-open="false"
                    ></div>
                `;
      }
    }

    $("body").removeClass("singleMatch");

    // 4) Combine everything into a final view
    let view = `
            <div class="eventShown"></div>
            <div class="searchHolder w-full relative">
                <div class="searchHeader bg-gradient-to-t from-[#232323] via-[#333333] to-[#494949] px-2 py-1 border-b border-[#3d3d3d] relative">
                    <div class="relative w-full flex flex-wrap flex-row w-full">
                        <img class="w-[14px] h-[14px] absolute left-1 top-[50%] -translate-y-1/2 pointer-none" src="~/../img/search.png" />
                        <input type="text" class="searchInputLabel bg-[rgba(255,255,255,0.2)] border border-[rgba(255,255,255,0.4)] text-white h-[20px] text-[12px] pl-5" />

                        <div class="helper absolute right-0 top-0 cursor-pointer w-[40px] h-[20px] z-10 hidden flex-wrap flex-row spasce-x-2 justify-between">
                            <div class="closeSearch flex items-center w-[20px] h-[20px]">
                                <span class="text-white text-[14px] w-[20px] leading-[20px] text-center font-bold">x</span>
                            </div>
                            <div class="closeSearch w-[20px] h-[20px]">
                                <svg class="w-full h-full fill-white" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="icon" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" style="enable-background:new 0 0 32 32;" xml:space="preserve">
                                    <path d="M28,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h24c1.1,0,2-0.9,2-2V6C30,4.9,29.1,4,28,4z M10,26H4V6h6V26z M28,15H17.8  l3.6-3.6L20,10l-6,6l6,6l1.4-1.4L17.8,17H28v9H12V6h16V15z"/>
                                    <rect id="_x3C_Transparent_Rectangle_x3E__589_" class="st0" width="32" height="32"/>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="searchContent absolute w-auto left-2 top-[29px] bg-white z-10 h-auto max-h-[calc(100vh-118px)] overflow-y-scroll ease-in-out duration-100" id="searchContent"></div>
            </div>
            <section class="leftPanel w-full overflow-y-auto h-[calc(100vh-118px)]">
                <div class="w-full">
                    <div class="menuItemListed w-full flex flex-col">
                        <div id="favorite-games" class="w-full bg-[red] h-auto p-[1px]"></div>
                        <div id="countryView">${countryView}</div>
                    </div>
                </div>
            </section>
        `;
    return view;
  },

  after_render: async () => {
    const currentUrlIsLive = window.location.hash; // Get current hash URL
    if (
      currentUrlIsLive.startsWith("#/livematch/") ||
      currentUrlIsLive.startsWith("#/inplay")
    ) {
      $("body").addClass("is-live");
    } else {
      $("body").removeClass("is-live");
    }

    const FAVORITES_KEY = "favoriteGames"; // stores an array of objects: {id, name, sport_id, result, current_minute}

    // ===== Minute Clock + Sync helpers (UNCHANGED LOGIC) =====
    let minuteClock = null;

    // Parse to MINUTES (int). Supports: "mm:ss", "mm’", "mm", "45+2", "45+2’". Skips HT/FT.
    function parseInitialMinutes(str) {
      if (!str) return null;
      const s = String(str).trim();
      if (/^(HT|FT)$/i.test(s)) return null;

      const mmss = s.match(/^(\d{1,3}):(\d{2})$/);
      if (mmss) return Math.floor((+mmss[1] * 60 + +mmss[2]) / 60);

      const stoppage = s.match(/^(\d{1,3})\+(\d{1,2})(?:['’])?$/);
      if (stoppage) return +stoppage[1] + +stoppage[2];

      const minOnly = s.match(/^(\d{1,3})['’]$/);
      if (minOnly) return +minOnly[1];

      const justMin = s.match(/^(\d{1,3})$/);
      if (justMin) return +justMin[1];

      return null;
    }

    function formatMinutes(min) {
      if (min == null) return "";
      return `${min}’`;
    }

    // Seed minute tracking on left-panel items without changing your render HTML:
    function seedMainListTimes() {
      const anchors = document.querySelectorAll(
        ".menuItemListed .league-group a[data-id]"
      );
      anchors.forEach((a) => {
        const minuteSpan = a.querySelector("div span"); // your first span is minute
        if (!minuteSpan) return;
        if (minuteSpan.classList.contains("live-time")) return; // already seeded

        const m = parseInitialMinutes(minuteSpan.textContent);
        if (m == null) return; // skip HT/FT or unknown

        minuteSpan.classList.add("live-time");
        minuteSpan.setAttribute("data-minutes", String(m));
        minuteSpan.textContent = formatMinutes(m);
      });
    }

    // Favorites will be rendered with minutes dataset directly (see renderFavoritesIntoContainer)
    function startMinuteClock() {
      if (minuteClock) return;

      // Immediately normalize displays once
      updateMinuteDisplays(false);

      // Then tick every minute
      minuteClock = setInterval(() => {
        updateMinuteDisplays(true);
      }, 60_000);
    }

    function updateMinuteDisplays(increment) {
      // Update favorites
      document.querySelectorAll(".fav-time").forEach((el) => {
        const mStr = el.getAttribute("data-minutes");
        if (mStr == null || mStr === "" || mStr === "null") return;
        let m = parseInt(mStr, 10);
        if (Number.isNaN(m)) return;
        if (increment) m += 1;
        el.setAttribute("data-minutes", String(m));
        el.textContent = formatMinutes(m);
      });

      // Update left panel items
      document.querySelectorAll(".live-time").forEach((el) => {
        const mStr = el.getAttribute("data-minutes");
        if (mStr == null || mStr === "" || mStr === "null") return;
        let m = parseInt(mStr, 10);
        if (Number.isNaN(m)) return;
        if (increment) m += 1;
        el.setAttribute("data-minutes", String(m));
        el.textContent = formatMinutes(m);
      });
    }

    // ===== Safe prune based on latest API response ONLY =====
    function getLastLiveIds() {
      try {
        return JSON.parse(localStorage.getItem("lastLiveIds") || "[]").map(
          String
        );
      } catch {
        return [];
      }
    }
    function canPruneByApi() {
      return localStorage.getItem("lastLiveIdsReady") === "1";
    }

    function pruneFavoritesNotIn(idsSet) {
      if (!canPruneByApi() || !idsSet || idsSet.size === 0) {
        return false; // do NOT prune unless we have a fresh API id set
      }
      const list = getFavoriteGames();
      const pruned = list.filter((f) => idsSet.has(String(f.id)));
      if (pruned.length !== list.length) {
        saveFavoriteGames(pruned);
        return true;
      }
      return false;
    }

    function refreshFavoriteFieldsFromDOM() {
      const list = getFavoriteGames();
      let changed = false;

      list.forEach((f) => {
        const selector = `.menuItemListed .league-group a[data-id="${CSS.escape(
          String(f.id)
        )}"]`;
        const a = document.querySelector(selector);
        if (!a) return;

        const spans = a.querySelectorAll("span");
        const minute = spans[0]?.textContent?.trim() ?? f.current_minute ?? "";
        const name = spans[1]?.textContent?.trim() ?? f.name ?? "";
        const result = spans[2]?.textContent?.trim() ?? f.result ?? "";

        if (
          minute !== f.current_minute ||
          name !== f.name ||
          result !== f.result
        ) {
          f.current_minute = minute;
          f.name = name;
          f.result = result;
          changed = true;
        }
      });

      if (changed) saveFavoriteGames(list);
      return changed;
    }
    // ===== END helpers =====

    function getFavoriteGames() {
      try {
        const favorites = JSON.parse(
          localStorage.getItem(FAVORITES_KEY) || "[]"
        );
        return filterBlockedSports(favorites, (game) => game?.sport_id);
      } catch {
        return [];
      }
    }

    function saveFavoriteGames(list) {
      const deduped = [];
      const seen = new Set();
      for (const g of list) {
        const id = String(g.id);
        if (!seen.has(id)) {
          seen.add(id);
          deduped.push({
            id,
            name: g.name ?? "",
            sport_id: g.sport_id ?? "",
            result: g.result ?? "",
            current_minute: g.current_minute ?? "",
          });
        }
      }
      localStorage.setItem(FAVORITES_KEY, JSON.stringify(deduped));
    }

    function isFavorite(id) {
      id = String(id);
      return getFavoriteGames().some((g) => String(g.id) === id);
    }

    function toggleFavorite(gameObj) {
      const id = String(gameObj.id);
      let list = getFavoriteGames();
      if (list.some((g) => String(g.id) === id)) {
        list = list.filter((g) => String(g.id) !== id);
      } else {
        list.push({
          id,
          name: gameObj.name,
          sport_id: String(
            gameObj["sport_id"] ??
              gameObj["sport-id"] ??
              gameObj["sportId"] ??
              ""
          ),
          result: gameObj.result ?? "",
          current_minute: gameObj.current_minute ?? gameObj.minute ?? "",
        });
      }
      saveFavoriteGames(list);
      return list;
    }

    function renderFavoritesIntoContainer() {
      const container = document.getElementById("favorite-games");
      if (!container) return;

      const favs = getFavoriteGames();

      if (!favs.length) {
        container.innerHTML = ``;
        container.classList.remove("p-[1px]");
        return;
      }

      const itemsHtml = favs
        .map(
          (f) => `
          
        <div class="w-full relative group">
            <a 
                href="#/livematch/${f.id}?sportId=${f.sport_id}" 
                class="flex flex-wrap w-full duration-300 ease-in-out justify-between items-center bg-black bg-opacity-[0.4] px-2 py-[1px] border-[#3d3d3d] border-b border-dotted cursor-pointer hover:bg-[#8d741d]"
                data-id="${f.id}">
                <div class="flex flex-row flex-wrap items-center w-full">
                <span 
                  class="fav-time text-white text-[11px] w-[22px]"
                  data-id="${f.id}"
                  data-minutes="${parseInitialMinutes(f.current_minute)}"
                >${formatMinutes(parseInitialMinutes(f.current_minute))}</span>
                <span class="text-white text-[11px] max-w-[calc(100%-42px)] w-full truncate px-2">${
                  f.name ?? ""
                }</span>
                <span class="text-white text-[11px] max-w-[50px] w-[20px] truncate">${
                  f.result ?? ""
                }</span>
                </div>
            </a>

            <!-- Make opacity change when parent is hovered -->
            <div 
                class="fav-toggle is-fav flex flex-wrap flex-col h-full w-[22px] absolute z-2 left-1 top-0 transition-opacity duration-300 cursor-pointer"
                id="${f.id}"
                data-id="${f.id}"
                data-name="${f.name ?? ""}"
                data-sport-id="${f.sport_id ?? ""}"
                data-result="${f.result ?? ""}"
                data-minute="${f.current_minute ?? ""}"
                title="${_t("Remove from favorites")}">
                <img class="w-full h-full object-contain p-1" src="./img/ILL.png">
            </div>
        </div>

  `
        )
        .join("");

      container.innerHTML = `
    <div class="FavTitle bg-[linear-gradient(to_bottom,_#232323_0px,_#000_27px)] bg-no-repeat bg-black text-white p-2 text-center text-[12px]" id="Fav">${_t(
      "Ndeshjet Kryesore"
    )}</div>
    ${itemsHtml}
  `;

      // ensure clock starts after first render of favorites
      container.classList.add("p-[1px]");
      startMinuteClock();
    }

    // Add/Remove highlight class on list items that are favorited
    function syncFavoriteBadgesInList() {
      document.querySelectorAll(".fav-toggle").forEach((el) => {
        const id = el.getAttribute("data-id") || el.id;
        const parent = el.closest(".relative, .w-full.relative"); // get parent wrapper
        const partnerLink = parent ? parent.querySelector("a") : null;

        if (id && isFavorite(id)) {
          el.classList.add("is-fav");
          el.style.opacity = "1";

          if (partnerLink) {
            partnerLink.classList.add("is-fav");
          }
        } else {
          el.classList.remove("is-fav");
          el.style.opacity = ""; // revert to default

          if (partnerLink) {
            partnerLink.classList.remove("is-fav");
          }
        }
      });
    }

    $("body").ready(function () {
      // Set the correct height dynamically after rendering
      $(".sport-content").each(function () {
        let contentHeight = $(this).prop("scrollHeight") + "px";
        $(this).css("height", contentHeight);
      });
    });

    // ===== jQuery delegated bindings (persistent across rerenders) =====

    // 1) Toggle favorite (works for both main list and favorites)
    $(document)
      .off("click.leftpanel.fav", ".fav-toggle")
      .on("click.leftpanel.fav", ".fav-toggle", function (e) {
        e.preventDefault();
        e.stopPropagation();

        const $btn = $(this);
        const data = {
          id: $btn.data("id") ?? $btn.attr("id"),
          name: $btn.data("name"),
          sport_id: $btn.data("sport-id"),
          result: $btn.data("result"),
          current_minute: $btn.data("minute"),
        };

        toggleFavorite(data);
        renderFavoritesIntoContainer(); // re-render favorites section
        syncFavoriteBadgesInList(); // update badges in the main list
        startMinuteClock(); // ensure ticking continues after re-render
      });

    // 2) Sport header expand/collapse
    $(document)
      .off("click.leftpanel.sheader", ".sport-header")
      .on("click.leftpanel.sheader", ".sport-header", function () {
        const $content = $(this).next(".sport-content");
        const $icon = $(this).find("img:last-child"); // Arrow icon

        if ($content.hasClass("open")) {
          $content.removeClass("open").css({ height: 0, opacity: 0 });
          $icon.css({ transform: "translateY(-50%) rotate(0deg)" }); // Arrow down
        } else {
          let contentHeight = $content.prop("scrollHeight") + "px"; // Get height dynamically
          $content.addClass("open").css({ height: contentHeight, opacity: 1 });
          $icon.css({ transform: "translateY(-50%) rotate(90deg)" }); // Arrow up
        }
      });

    // 3) Search UI toggles
    $(document)
      .off("click.leftpanel.searchopen", "#searchTrigger")
      .on("click.leftpanel.searchopen", "#searchTrigger", function () {
        $("body").addClass("showDescSearch");
        $("body .searchHolder").addClass("show");
        $("body .searchInputLabel").focus();
      });

    $(document)
      .off("click.leftpanel.searchclose", ".closeSearch")
      .on("click.leftpanel.searchclose", ".closeSearch", function () {
        $("body .searchInputLabel").val("");
        $("body .searchInputLabel").blur();
        $("#searchContent").html("");
        $("body .helper").removeClass("flex");
        $("body .helper").addClass("hidden");
      });

    $(document)
      .off("click.leftpanel.clear", ".clearInput")
      .on("click.leftpanel.clear", ".clearInput", function () {
        $("body .searchInputLabel").val("");
        $("body .searchInputLabel").focus();
        $("#searchContent").html("");
      });

    // 4) Search input (kept as is, just ensure one handler)
    $(document)
      .off("keyup.leftpanel.search", "body .searchInputLabel")
      .on(
        "keyup.leftpanel.search",
        "body .searchInputLabel",
        delay(async function (e) {
          const $input = $("body .searchInputLabel").val();

          const $content = $("body #searchContent");
          const $helper = $("body .helper");

          // Reset when empty
          if ($input.length === 0) {
            $input.val("").focus();
            $helper.removeClass("flex").addClass("hidden");
            return;
          }

          // Only search when 3+ chars
          if ($input.length < 2) return;

          try {
            const searchValues = await getSearchGames($input);

            if (!Array.isArray(searchValues) || searchValues.length === 0) {
              // No results
              $content.html(``);
              $helper.removeClass("flex").addClass("hidden");
              return;
            }

            // Get unique, sorted YYYY-MM-DD dates (lexicographic works for ISO)
            const uniqueDates = [
              ...new Set(searchValues.map((i) => i.game_date)),
            ].sort();

            let searchGamesView = "";

            uniqueDates.forEach((date) => {
              let singleDateView = "";

              const currentUrlIsLive = window.location.hash; // Get current hash URL
              const base = searchValues
                // skip invalid/excluded
                .filter((a) => a?.odd && a.id !== 372481 && a?.type_id != null); // require type_id

              if (
                currentUrlIsLive.startsWith("#/livematch/") ||
                currentUrlIsLive.startsWith("#/inplay")
              ) {
                // LIVE/INPLAY: only type_id === 1
                base
                  .filter((a) => Number(a.type_id) !== 1)
                  .forEach((a) => {
                    // place into the correct date section (no up-front date filter)
                    if (a.game_date !== date) return;
                    singleDateView += getSearchingGames(a, a.type_id); // fixed typo
                  });
              } else {
                // NON-LIVE: everything except type_id === 1
                base
                  .filter((a) => Number(a.type_id) === 1)
                  .forEach((a) => {
                    if (a.game_date !== date) return;
                    singleDateView += getSearchingGames(a, a.type_id);
                  });
              }

              if (singleDateView) {
                searchGamesView += `
      <div class="searchLabelGroup flex flex-wrap flex-row w-full">
        <div class="search-games w-full space-y-2">
          <ul>${singleDateView}</ul>
        </div>
      </div>
    `;
              }
            });

            // If all items were filtered out, show "no results"
            if (!searchGamesView) {
              $content.html(`
                <div class="p-3 text-sm text-white/80 bg-black/40">
                No matches for "<span class="font-semibold">${term}</span>".
                </div>
            `);
            } else {
              $content.html(searchGamesView);
            }

            // Open panel
            $helper.removeClass("hidden").addClass("flex");
          } catch (err) {
            console.error("Search error:", err);
            $content.html(`
          <div class="p-3 text-sm text-red-300 bg-black/40">
            Something went wrong while searching. Please try again.
          </div>
        `);
            $helper.removeClass("hidden").addClass("flex");
          }
        }, 300)
      );

    // 5) Country row click (delegated)
    $(document)
      .off("click.leftpanel.country", ".countryRow")
      .on("click.leftpanel.country", ".countryRow", async function () {
        const $row = $(this);
        const countryId = $row.data("id");
        const leagueContainer = document.getElementById(
          `league-container-${countryId}`
        );
        const loadedAlready =
          $row.data("loaded") === true || $row.attr("data-loaded") === "true";

        if (!loadedAlready) {
          let leagues = await getLeagues(countryId);
          let leagueView = "";
          leagues.forEach((league) => {
            leagueView += `
                            <div
                                class="leagueListContentItem duration-150 ease-in-out countryRow flex flex-wrap w-full justify-between pl-4 pr-2 items-center min-h-[28px] h-[28px] border-b border-[rgba(255,255,255,0.1)] cursor-pointer hover:bg-[#8d741d]"
                                data-id="${league.id}"
                            >
                                <div class="flex flex-row flex-wrap items-center w-full  space-x-2 flex-1 overflow-hidden">
                                    <span class="text-white text-[11px] leading-[17px] truncate whitespace-nowrap overflow-hidden text-ellipsis max-w-[80%]">
                                        ${_t(league.name)}
                                    </span>
                                </div>
                                <div class="flex flex-row flex-wrap items-center max-w-[30px]">
                                    <span class="leagueCount text-[#ffcc00] text-[11px] leading-[17px]">(${
                                      league.count_leagues
                                    })</span>
                                </div>
                            </div>
                        `;
          });
          leagueContainer.innerHTML = leagueView;
          $row.attr("data-loaded", "true");
        }

        let games = await getGamesByCountry(countryId);
        if (!games.length) {
          document.getElementById("content_container").innerHTML = `<h3>${_t(
            "Ska loje"
          )}</h3>`;
          return;
        }

        const uniqueDates = [
          ...new Set(games.map((item) => item.game_date)),
        ].sort();

        let gamesView = uniqueDates
          .map((date) => {
            let singleDateView = games
              .filter((game) => game.game_date === date)
              .map((game) =>
                game.odd ? getGameTemplate(game, game.sport_id) : ""
              )
              .join("");

            return `
                        <div class="flex flex-wrap flex-row w-full">
                            <div class="flex w-full text-[11px] px-1 text-[#ffff00] bg-black/40">
                                <span>${date}</span>
                            </div>
                            <div class=" titleTobeHidden flex w-full text-[11px] leading-[20px] h-[20px] px-1 text-[#ffff00] border-l-[2px] border-[#008000]">
                                <span class="pl-1">Rezultat Final</span>
                            </div>
                            <div class="flex flex-row flex-wrap w-full">
                                ${singleDateView}
                            </div>
                        </div>
                    `;
          })
          .join("");

        if (!gamesView) {
          gamesView = `<h3>${_t("Ska loje")}</h3>`;
        }

        const currentUrl = window.location.hash; // Get current hash URL
        if (
          currentUrl.startsWith("#/Match/") ||
          currentUrl.startsWith("#/match/")
        ) {
          $("body").addClass("singleMatch");
        }
        document.getElementById("gamesLeagueWrapper").innerHTML = gamesView;

        // toggle accordion
        toggleAccordion(leagueContainer, $row[0]);
      });

    // 6) League click (delegated)
    $(document)
      .off("click.leftpanel.league", ".leagueListContentItem")
      .on(
        "click.leftpanel.league",
        ".leagueListContentItem",
        async function () {
          const leagueId = $(this).data("id");

          let games = await getGames(leagueId);
          if (!games.length) {
            document.getElementById("content_container").innerHTML = `<h3>${_t(
              "Ska loje"
            )}</h3>`;
            return;
          }

          const uniqueDates = [
            ...new Set(games.map((item) => item.game_date)),
          ].sort();

          let gamesView = uniqueDates
            .map((date) => {
              let singleDateView = games
                .filter((game) => game.game_date === date)
                .map((game) =>
                  game.odd ? getGameTemplate(game, game.sport_id) : ""
                )
                .join("");

              return `
                            <div class="flex flex-wrap flex-row w-full">
                                <div class="flex w-full text-[11px] px-1 text-[#ffff00] bg-black/40">
                                    <span>${date}</span>
                                </div>
                                <div class="titleTobeHidden flex w-full text-[11px] leading-[20px] h-[20px] px-1 text-[#ffff00] border-l-[2px] border-[#008000]">
                                    <span class="pl-1">Rezultat Final</span>
                                </div>
                                <div class="flex flex-row flex-wrap w-full">
                                    ${singleDateView}
                                </div>
                            </div>
                        `;
            })
            .join("");

          if (!gamesView) {
            gamesView = `<h3>${_t("Ska loje")}</h3>`;
          }

          const currentUrl = window.location.hash; // Get current hash URL
          if (
            currentUrl.startsWith("#/Match/") ||
            currentUrl.startsWith("#/match/")
          ) {
            $("body").addClass("singleMatch");
          }
          document.getElementById("gamesLeagueWrapper").innerHTML = gamesView;
        }
      );
    // 2) On initial render, paint favorites + seed/tick minutes everywhere
    renderFavoritesIntoContainer();
    syncFavoriteBadgesInList();
    seedMainListTimes(); // <-- seed main (non-favorites) minutes to mm’
    startMinuteClock(); // <-- tick every minute for both

    // 3) Safe prune ONLY when we have fresh API ids (in-play flow)
    const apiIdList = getLastLiveIds();
    const apiIdSet = new Set(apiIdList);
    const pruned = pruneFavoritesNotIn(apiIdSet);
    const updated = refreshFavoriteFieldsFromDOM();
    if (pruned || updated) {
      renderFavoritesIntoContainer();
      syncFavoriteBadgesInList();
      seedMainListTimes();
      startMinuteClock();
    }

    function delay(callback, ms) {
      var timer = 0;
      return function () {
        var context = this,
          args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
          callback.apply(context, args);
        }, ms || 0);
      };
    }
    function toggleAccordion(container, row) {
      const isOpen = container.dataset.open === "true";
      const icon = row.querySelector(".toggle-icon");

      if (isOpen) {
        container.style.height = container.scrollHeight + "px";
        requestAnimationFrame(() => {
          container.style.height = "0px";
          container.dataset.open = "false";
          icon.style.transform = "rotate(0deg)";
        });
      } else {
        container.style.height = container.scrollHeight + "px";
        container.dataset.open = "true";
        icon.style.transform = "rotate(90deg)";
      }
    }
    /***** -----------------------------------------------------------
     *  GLOBAL CACHES (place above the event listener)
     *  ----------------------------------------------------------- *****/

    // --- Countries (prematch) cache ---
    window.__countriesCache ??= new Map(); // key: matchSport -> { data, ts }

    async function getCountriesCached(
      matchSport,
      { ttlMs = 120_000, force = false } = {}
    ) {
      const key = String(matchSport ?? "");
      const now = Date.now();
      const cached = window.__countriesCache.get(key);

      if (
        !force &&
        cached &&
        now - cached.ts < ttlMs &&
        Array.isArray(cached.data)
      ) {
        return cached.data;
      }
      const data = await getCountries(matchSport);
      window.__countriesCache.set(key, { data, ts: now });
      return data;
    }

    function invalidateCountriesCache(matchSport) {
      window.__countriesCache.delete(String(matchSport ?? ""));
    }
    function clearCountriesCache() {
      window.__countriesCache.clear();
    }

    // --- Live left-panel cache ---
    window.__liveLeftPanelCache ??= new Map(); // key: sportId -> { data, ts }

    async function getLiveLeftPanelGamesCached(
      sportId,
      { ttlMs = 30_000, force = false } = {}
    ) {
      const key = String(sportId ?? "");
      const now = Date.now();
      const cached = window.__liveLeftPanelCache.get(key);

      if (
        !force &&
        cached &&
        now - cached.ts < ttlMs &&
        Array.isArray(cached.data)
      ) {
        return cached.data;
      }
      const data = await getLiveLeftPanelGames(sportId);
      window.__liveLeftPanelCache.set(key, { data, ts: now });
      return data;
    }

    function invalidateLiveCache(sportId) {
      window.__liveLeftPanelCache.delete(String(sportId ?? ""));
    }
    function clearLiveCache() {
      window.__liveLeftPanelCache.clear();
    }

    /***** -----------------------------------------------------------
     *  YOUR EXISTING LISTENER (with minimal changes where noted)
     *  ----------------------------------------------------------- *****/

    window.addEventListener("hashchange", async () => {
      $("body .closeSearch ").click();
      const currentUrlIsLive = window.location.hash; // Get current hash URL
      if (
        currentUrlIsLive.startsWith("#/livematch/") ||
        currentUrlIsLive.startsWith("#/inplay")
      ) {
        $("body").addClass("is-live");
      } else {
        $("body").removeClass("is-live");
      }
      let request = Utils.parseRequestURL();
      let matchSport = localStorage.getItem("matchSport");
      const currentUrl = window.location.hash;
      let countries = [];

      if (
        currentUrl.startsWith("#/inplay") ||
        currentUrl.startsWith("#/livematch/")
      ) {
        localStorage.setItem("matchSport", "0");
        matchSport = localStorage.getItem("matchSport");

        if (
          prevHash.includes("#/livematch/") ||
          prevHash.includes("#/inplay")
        ) {
          renderFavoritesIntoContainer();
          syncFavoriteBadgesInList();
          seedMainListTimes(); // <-- seed main (non-favorites) minutes to mm’
          startMinuteClock(); // <-- tick every minute for both
        } else {
          const allowedLiveSportIds = LIVE_SPORT_IDS.filter(
            (sportId) => !isSportBlocked(sportId)
          );
          const liveSportGames = await Promise.all(
            allowedLiveSportIds.map(
              async (sportId) =>
                (await getLiveLeftPanelGamesCached(sportId)) || []
            )
          );
          countries = [].concat(...liveSportGames);
          try {
            const ids = [
              ...new Set(
                (countries || []).map((x) => String(x.id)).filter(Boolean)
              ),
            ];
            localStorage.setItem("lastLiveIds", JSON.stringify(ids));
            localStorage.setItem("lastLiveIdsReady", "1");
          } catch {}

          printLeftPanelView(countries, "0");

          renderFavoritesIntoContainer();
          syncFavoriteBadgesInList();
          seedMainListTimes(); // <-- seed main (non-favorites) minutes to mm’
          startMinuteClock(); // <-- tick every minute for both
        }
      }

      if (
        currentUrl.startsWith("#/Match") ||
        currentUrl.startsWith("#/match/")
      ) {
        if (
          prevHash.includes("#/match/") ||
          prevHash.includes("#/Match/") ||
          prevHash.includes("#/sports/")
        ) {
        } else {
          localStorage.setItem("matchSport", matchSport);
          matchSport = localStorage.getItem("matchSport");

          // CHANGED: use cached in this static-ish case
          countries = isSportBlocked(matchSport)
            ? []
            : await getCountriesCached(matchSport);

          printLeftPanelView(countries, matchSport);
        }
      }

      if (currentUrl.startsWith("#/") === "" || currentUrl === "#/") {
        matchSport = await getDefaultAllowedSportId();

        if (matchSport) {
          localStorage.setItem("matchSport", matchSport);
          countries = await getCountriesCached(matchSport);
        } else {
          countries = [];
        }

        printLeftPanelView(countries, matchSport);
      }

      if (currentUrl.startsWith("#/sports")) {
        if (isSportBlocked(request.id)) {
          printLeftPanelView([], request.id);
          return;
        }

        localStorage.setItem("matchSport", request.id);
        matchSport = localStorage.getItem("matchSport");

        // CHANGED: dynamic sports route now cached too (shorter TTL)
        countries = await getCountriesCached(matchSport, { ttlMs: 60_000 });

        printLeftPanelView(countries, request.id);
      }

      function printLeftPanelView(countries = [], matchSport = "0") {
        let countryView = "";

        if (matchSport === "0") {
          // Live view: group once by sport, then by league
          const groupedSports = {};
          for (const country of countries) {
            if (!groupedSports[country.sport_id]) {
              groupedSports[country.sport_id] = [];
            }
            groupedSports[country.sport_id].push(country);
          }

          countryView = Object.keys(groupedSports)
            .map((sportId) => {
              let sportName = "";
              let sportIcon = "";

              switch (parseInt(sportId)) {
                case 1:
                  sportName = "Football";
                  sportIcon = "soccer.svg";
                  break;
                case 2:
                  sportName = "Basketball";
                  sportIcon = "basketball.svg";
                  break;
                case 5:
                  sportName = "Tennis";
                  sportIcon = "tennis.svg";
                  break;
                case 20:
                  sportName = "Ping Pong";
                  sportIcon = "table.svg";
                  break;
                default:
                  sportName = "Other Sports";
                  sportIcon = "default.svg";
                  break;
              }

              // Group by league for this sport
              const leagueGroups = {};
              groupedSports[sportId].forEach((match) => {
                if (!leagueGroups[match.league]) {
                  leagueGroups[match.league] = [];
                }
                leagueGroups[match.league].push(match);
              });

              // Render leagues
              const leaguesHtml = Object.entries(leagueGroups)
                .map(([leagueName, matches]) => {
                  return `
              <div class="league-group w-full">
                <div class="league-title bg-[rgba(0,0,0,.7)] text-white px-4 py-2 text-[11px] font-normal border-b border-[#444] cursor-pointer">
                  ${_t(leagueName)}
                </div>
                ${matches
                  .map(
                    (country) => `
                      <div class="w-full relative">
                        <a
                          href="#/livematch/${country.id}?sportId=${country.sport_id}"
                          class="flex flex-wrap w-full duration-300 ease-in-out justify-between items-center bg-black bg-opacity-[0.4] px-2 py-[1px] border-[#3d3d3d] border-b border-dotted cursor-pointer hover:bg-[#8d741d]"
                          data-id="${country.id}">
                          <div class="flex flex-row flex-wrap items-center w-full">
                            <span class="text-white text-[11px] w-[22px]">${country.current_minute}</span>
                            <span class="text-white text-[11px] max-w-[calc(100%-42px)] w-full truncate px-2">${country.name}</span>
                            <span class="text-white text-[11px] max-w-[50px] w-[20px] truncate">${country.result}</span>
                          </div>
                        </a>

                        <!-- Favorite toggle button -->
                        <div
                          class="fav-toggle flex flex-wrap flex-col h-[calc(100%-1px)] w-[22px] absolute z-2 left-1 top-0 bg-[#202020] opacity-0 hover:opacity-100 cursor-pointer"
                          id="${country.id}"
                          data-id="${country.id}"
                          data-name="${country.name}"
                          data-sport-id="${country.sport_id}"
                          data-result="${country.result}"
                          data-minute="${country.current_minute}"
                          title="Toggle favorite">
                          <img class="w-full h-full object-contain p-1" src="./img/ILL.png">
                        </div>
                      </div>
                    `
                  )
                  .join("")}
              </div>
            `;
                })
                .join("");

              // Final render for this sport
              return `
          <div class="sport-group">
            <div class="sport-header flex flex-row items-center space-x-2 bg-[#333] border-b border-[#3d3d3d] text-white px-2 py-1 font-bold bg-gradient-to-t from-[#232323] via-[#333333] to-[#494949] cursor-pointer relative">
              <img class="w-[18px] h-[18px]" src="./img/${sportIcon}" alt="${sportName}" />
              <span class="text-white text-[11px] leading-[17px]">${_t(
                sportName
              )}</span>
              <img src="./img/right.png" class="ml-auto w-[11px] absolute right-2 top-1/2 -translate-y-1/2 rotate-[90deg] transition-transform duration-300" />
            </div>
            <div class="sport-content open overflow-hidden transition-all duration-300 ease-in-out h-auto opacity-100">
              ${leaguesHtml}
            </div>
          </div>
        `;
            })
            .join("");
        } else {
          // Prematch view: simple country rows
          countryView = countries
            .map(
              (country) => `
          <div
            class="countryRow flex flex-wrap w-full duration-300 ease-in-out justify-between items-center px-2 py-1 border-[#3d3d3d] bg-black bg-opacity-[0.6] border-b border-dotted cursor-pointer hover:bg-[#8d741d]"
            data-id="${country.id}"
            data-loaded="false"
          >
            <div class="flex flex-row flex-wrap items-center space-x-2">
              <img class="toggle-icon duration-300 ease-in-out w-[10px] h-[10px] transform" src="~/../img/right.png" />
              <span class="text-white text-[11px] leading-[17px]">${_t(
                country.name
              )}</span>
            </div>
            <div class="flex flex-row flex-wrap items-center">
              <span class="leagueCount text-[#ffcc00] text-[11px] leading-[17px]">(${
                country.count_country
              })</span>
            </div>
          </div>
          <div
            id="league-container-${country.id}"
            class="leagueContainer border-b border-[#3d3d3d] bg-black bg-opacity-20 overflow-hidden"
            style="height: 0; transition: height 0.3s ease;"
            data-open="false"
          ></div>
        `
            )
            .join("");
        }

        $("body #countryView").html(countryView);
        $("body").removeClass("singleMatch");
      }
    });
  },
};

export { Leftpanel, sports };
